<div class="container">
    <app-new-address [formControl]="addressForm"></app-new-address>
    <button
      mat-raised-button
      action-button
      color="primary"
      class="width-100"
      [disabled]="addressForm.invalid"
      [action]="createAddress.bind(this)"
      type="button">
      Dodaj adres
    </button>
</div>
